/* eslint-disable react/no-children-prop */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { inject, observer } from "mobx-react";
import { Link, Route } from "react-router-dom";

import { UiStoreContext } from "../stores/UiStore";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

import MailIcon from "@material-ui/icons/Mail";
import PersonIcon from "@material-ui/icons/Person";
import PhoneIcon from "@material-ui/icons/Phone";

import StrellaLogo from "../img/logo-full.png";

/* Constants for styles */
const drawerPaddingLeft = "1.25rem";

//
// VarietyList
//

class UnstyledVarietyList extends React.Component {
  static styles() {
    return {
      List: {
        padding: "0rem"
      },
      Subheader: {
        padding: "0rem",
        margin: "0rem",
        paddingLeft: drawerPaddingLeft,

        marginBottom: "1.25rem",

        fontSize: "1rem",
        lineHeight: "1.25rem",
        color: "#202C4A"
      },

      Link: {
        textDecoration: "none"
      },

      ListItem: {
        padding: ".375rem 0rem",
        margin: "0rem",
        paddingLeft: drawerPaddingLeft
      },

      ListItemActive: {
        backgroundColor: "#F5F6FA",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "0",
          left: "0",
          backgroundColor: "#AFC322",
          height: "100%",
          width: "0.25rem"
        }
      },

      ListItemText: {
        padding: "0rem",
        margin: "0rem"
      },

      ListItemTextTypography: {
        fontSize: "1rem",
        lineHeight: "1.25rem",
        color: "#737F8C"
      },

      ListItemTextTypographyActive: {
        fontWeight: "bold"
      }
    };
  }

  render() {
    const classes = this.props.classes;

    const activeListItemClass = clsx(classes.ListItem, classes.ListItemActive);

    const activeListItemTextTypographyClass = clsx(
      classes.ListItemTextTypography,
      classes.ListItemTextTypographyActive
    );

    return (
      <List
        className={classes.List}
        subheader={
          <ListSubheader className={classes.Subheader}>Varieties</ListSubheader>
        }
      >
        {(this.props.user || {}).is_staff && (
          <Route
            key={"overview"}
            path={`/overview/`}
            children={({ match }) => (
              <Link to={`/overview/`} className={classes.Link}>
                <ListItem
                  className={match ? activeListItemClass : classes.ListItem}
                >
                  <ListItemText
                    className={classes.ListItemText}
                    primary={"All Varieties"}
                    classes={{
                      primary: match
                        ? activeListItemTextTypographyClass
                        : classes.ListItemTextTypography
                    }}
                  />
                </ListItem>
              </Link>
            )}
          />
        )}
        {this.props.roomStore
          .varietiesForSeasons(this.context.selectedSeasons)
          .map(v => (
            <Route
              key={v.id}
              path={`/varieties/${v.id}/`}
              children={({ match }) => (
                <Link to={`/varieties/${v.id}/`} className={classes.Link}>
                  <ListItem
                    key={v.id}
                    className={match ? activeListItemClass : classes.ListItem}
                  >
                    <ListItemText
                      className={classes.ListItemText}
                      primary={v.human_name}
                      classes={{
                        primary: match
                          ? activeListItemTextTypographyClass
                          : classes.ListItemTextTypography
                      }}
                    />
                  </ListItem>
                </Link>
              )}
            />
          ))}
        {!(this.props.user || {}).is_staff && (
          <Route
            key={"overview"}
            path={`/overview/`}
            children={({ match }) => (
              <Link to={`/overview/`} className={classes.Link}>
                <ListItem
                  className={match ? activeListItemClass : classes.ListItem}
                >
                  <ListItemText
                    className={classes.ListItemText}
                    primary={"All Varieties"}
                    classes={{
                      primary: match
                        ? activeListItemTextTypographyClass
                        : classes.ListItemTextTypography
                    }}
                  />
                </ListItem>
              </Link>
            )}
          />
        )}
      </List>
    );
  }
}
UnstyledVarietyList.contextType = UiStoreContext;

const VarietyList = withStyles(UnstyledVarietyList.styles)(
  inject(stores => ({
    user: stores.rootStore.authStore.user,
    roomStore: stores.rootStore.roomStore
  }))(observer(UnstyledVarietyList))
);

// VarietyList

//
// ContactDetails
//

class UnstyledContactDetails extends React.Component {
  static styles() {
    return {
      List: {
        padding: "0rem",
        margin: "0rem"
      },

      Subheader: {
        padding: "0rem",
        margin: "0rem",
        paddingLeft: drawerPaddingLeft,
        marginBottom: "1.25rem",
        fontSize: "1rem",
        lineHeight: "1.25rem",
        color: "#202C4A"
      },

      Item: {
        padding: "0rem",
        margin: "0rem",
        paddingLeft: drawerPaddingLeft,
        marginTop: ".75rem"
      },

      ItemIcon: {
        padding: "0rem",
        margin: "0rem",
        fontSize: ".875rem",
        lineHeight: "1.125rem",
        color: "#0A0E34",

        marginRight: "0.5rem"
      },

      ItemText: {
        padding: "0rem",
        margin: "0rem"
      },

      ItemTextTypography: {
        fontSize: ".875rem",
        lineHeight: "1.125rem",
        color: "#0A0E34"
      },

      VersionItemTextTypography: {
        color: "#737F8C"
      }
    };
  }

  render() {
    const classes = this.props.classes;

    return (
      <List
        className={classes.List}
        subheader={
          <ListSubheader className={classes.Subheader}>
            Contact Details
          </ListSubheader>
        }
      >
        <ListItem className={classes.Item}>
          <PersonIcon className={classes.ItemIcon} />
          <ListItemText
            className={classes.ItemText}
            primary={"Jay Jordan"}
            classes={{
              primary: classes.ItemTextTypography
            }}
          />
        </ListItem>
        <ListItem className={classes.Item}>
          <MailIcon className={classes.ItemIcon} />
          <ListItemText
            className={classes.ItemText}
            primary={"jay@strellabiotech.com"}
            classes={{
              primary: classes.ItemTextTypography
            }}
          />
        </ListItem>
        <ListItem className={classes.Item}>
          <PhoneIcon className={classes.ItemIcon} />
          <ListItemText
            className={classes.ItemText}
            primary={"(267) 251-3749"}
            classes={{
              primary: classes.ItemTextTypography
            }}
          />
        </ListItem>
        <ListItem className={classes.Item}>
          <ListItemText
            className={classes.ItemText}
            // eslint-disable-next-line no-undef
            primary={`Strella Dashboard ${process.env.REACT_APP_VERSION ||
              "N/A"}`}
            classes={{
              primary: clsx(
                classes.ItemTextTypography,
                classes.VersionItemTextTypography
              )
            }}
          />
        </ListItem>
      </List>
    );
  }
}
const ContactDetails = withStyles(UnstyledContactDetails.styles)(
  inject(stores => ({
    roomStore: stores.rootStore.roomStore
  }))(observer(UnstyledContactDetails))
);

// ContactDetails

//
// OrganizationDetails
//

class UnstyledOrganizationDetails extends React.Component {
  static styles() {
    return {
      FormControl: {
        width: "100%",
        paddingLeft: drawerPaddingLeft,
        paddingRight: drawerPaddingLeft
      },

      Main: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },

      CompanyAvatar: {
        width: "1.25rem",
        height: "1.25rem",
        marginRight: "6px"
      },

      CompanyName: {
        fontSize: "0.875rem",
        lineHeight: "1rem",
        color: "#0A0E34"
      },

      LogoutButton: {
        color: "#FF0000"
      }
    };
  }

  render() {
    const classes = this.props.classes;

    const organizationName =
      ((this.props.authStore.user || {}).organization || {}).name || "";

    const actions = {
      logout: () => this.props.authStore.logout()
    };

    return (
      <FormControl variant="outlined" className={classes.FormControl}>
        <Select
          value={"company"}
          renderValue={() => (
            <div className={classes.Main}>
              <Avatar className={classes.CompanyAvatar}>
                {organizationName.toUpperCase().charAt(0) || undefined}
              </Avatar>
              <Typography noWrap={true} className={classes.CompanyName}>
                {organizationName || "No Organization"}
              </Typography>
            </div>
          )}
          onChange={e => (actions[e.target.value] || (() => {}))()}
        >
          <MenuItem
            value={"company"}
            key="company"
            style={{ display: "none" }}
          />
          <MenuItem
            value={"logout"}
            key="logout"
            className={classes.LogoutButton}
          >
            <Typography>Logout</Typography>
          </MenuItem>
          {(this.props.authStore.user || {}).is_staff
            ? [
                <MenuItem
                  value={"settings"}
                  key="settings"
                  component={Link}
                  to={"/settings"}
                >
                  Settings
                </MenuItem>,
                <MenuItem
                  value={"demo-mode"}
                  key="demo-mode"
                  component={Link}
                  to={"/view-selector"}
                >
                  Demo Mode
                </MenuItem>
              ]
            : []}
        </Select>
      </FormControl>
    );
  }
}
const OrganizationDetails = withStyles(UnstyledOrganizationDetails.styles)(
  inject(stores => ({
    authStore: stores.rootStore.authStore
  }))(observer(UnstyledOrganizationDetails))
);

// OrganizationDetails

class Sidebar extends React.Component {
  static styles() {
    return {
      Drawer: {
        width: "15rem"
      },

      FlexContainer: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      },

      Logo: {
        height: "4rem",
        width: "auto",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        paddingLeft: drawerPaddingLeft,
        paddingRight: "1.5rem"
      },

      ContactDetails: {
        padding: "1.25rem 0rem"
      },

      OrganizationDetails: {
        padding: "1.25rem 0rem"
      }
    };
  }

  render() {
    const classes = this.props.classes;

    return (
      <Drawer
        variant="permanent"
        className={classes.Drawer}
        classes={{ paper: classes.Drawer }}
      >
        <Box className={classes.FlexContainer}>
          <Box className={classes.FlexContainer}>
            <Box style={{ marginLeft: "auto", marginRight: "auto" }}>
              <img
                src={StrellaLogo}
                className={classes.Logo}
                alt={"Strella Biotechnology"}
              />
            </Box>
            <Box className={classes.VarietyList}>
              <VarietyList />
            </Box>
          </Box>
          <Box>
            <Divider />
            <Box className={classes.ContactDetails}>
              <ContactDetails />
            </Box>
            <Divider />
            <Box className={classes.OrganizationDetails}>
              <OrganizationDetails />
            </Box>
          </Box>
        </Box>
      </Drawer>
    );
  }
}

export default withStyles(Sidebar.styles)(observer(Sidebar));
